export const isDevelopment = () => {
  return process.env.REACT_APP_ENVIRONMENT === 'development'
}
